import React from 'react'
import './index.less'
import Goods from '../components/Goods/index'
import OrderInfo from '../components/OrderInfo/index'
import {postInfo} from '@/api/cancelRecord/details'
import dayjs from "dayjs";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import {message, Row, Col, Spin,} from 'antd'

class Details extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            page: {goodItemVOS:[]},
            extra: {},
        }
        this.search = this.getParamsSearch()

    }

    componentDidMount() {
        this.getDetails()
    }

    getParamsSearch() {
        let params = this.props.location.search
        let search = {}
        if (params) {
            params = params.split('?')[1]
            params = params.split('&')
            params.forEach((item, index) => {
                let param = item.split('=')
                search[param[0]] = param[1]
            })
        }
        return search
    }

    getDetails() {
        this.setState({
            loading: true,
        }, () => {
            postInfo({
                id: Number(this.search.id),
            }).then(res => {
                this.setState({
                    loading: false,
                })
                if (res.data.success && res.data.valid) {
                    this.setState({
                        page: res.data.model,
                        extra: res.data.extra,
                    })
                } else {
                    message.info(res.data.message);
                }
            })
        })
    }

    copyHandler() {
        const txt = document.getElementById('orderId')
        const range = document.createRange()
        window.getSelection().removeAllRanges()
        range.selectNode(txt)
        window.getSelection().addRange(range)
        const successful = document.execCommand('copy')
        if (successful) {
            message.success(__getServerLanguage('FuZhiChengGong'))
            window.getSelection().removeAllRanges()
        }
    }

    render() {
        const {page={}, extra,loading} = this.state
        const currPageName = Lang({id: "KeHuQuXiaoDengJiXiangQing",default: "客户取消登记详情"});
        const pageName = Lang({id: "PoDanLieBiao",default: "订单列表"});
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:pageName,link:'/order/sale'},{name:page&&page.orderNumber?page.orderNumber:''}]}></CommonBreadcrumb>
            <div className="cancelRecord-details">
                <p className="font-title fw_500 font_15 mb_16 lineH_22">{currPageName}</p>

                <div className="mb_16">
                    <span className="font-title font_15 fw_500 mr_4">
                        {__getServerLanguage('DanHao')}
                    </span>
                    <span id="orderId" className="font-main2 font_15 fw_500 mr_8">
                        {page.orderNumber}
                    </span>
                    <span className="copy-txt btn-link font_13 con2-txt" onClick={this.copyHandler.bind(this)}>
                        {__getServerLanguage('FuZhi')}
                    </span>
                </div>

                <div className="mb_16" data-flex="cross:center">
                    <p className="font_13 fw_400 con2-txt mr_24">
                        <span>{__getServerLanguage('CaoZuoRen')}</span>
                        <span className="ml_8 font-title">{page.currentUser}</span>
                    </p>
                    <p className="font_13 fw_400 con2-txt mr_24">
                        <span>{__getServerLanguage('DengJiRiQi')}</span>
                        <span className="ml_8 font-title">{page.registerTime?dayjs(page.registerTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</span>
                    </p>
                    <p className="font_13 fw_400 con2-txt mr_24">
                        <span>{__getServerLanguage('HeJi')}</span>
                        <span className="ml_8 font-title">
                            {page.skuNum}{__getServerLanguage('Kuan')}，{page.quantity}{__getServerLanguage('Xiang')}
                            （{__getServerLanguage('ZhengChangDengJi')}  {page.normalQuantity}{__getServerLanguage('Xiang')}， {__getServerLanguage('PoSunDengJi')}  {page.damagedQuantity}{__getServerLanguage('Xiang')}）
                        </span>
                    </p>
                </div>

                <div className="mb_16">
                    <OrderInfo info={page}/>
                </div>

                <div className="details-con">
                    <div className="con-th">
                        <Row>
                            <Col span={14}>{__getServerLanguage('ShangPinXinXi')}</Col>
                            <Col span={10}>{__getServerLanguage('DengJiXinXi')}</Col>
                        </Row>
                    </div>

                    <div className="con-tb">
                        {page.goodItemVOS&&page.goodItemVOS.map((item, index) => (
                            <Row key={index.toString()}>
                                <Col span={14}>
                                    <Goods data={item} currencySymbol={extra.currencySymbol}></Goods>
                                </Col>
                                <Col span={10}>
                                    <div className="mt_16 fw_500 font-title lineH_19 font_13">
                                        <p className="mb_8">
                                            {__getServerLanguage('ZhengChangDengJi')}  {item.normalQuantity}{__getServerLanguage('Xiang')}， {__getServerLanguage('PoSunDengJi')}  {item.damagedQuantity}{__getServerLanguage('Xiang')}
                                        </p>

                                        <p>
                                            {__getServerLanguage('BeiZhu')}：{item.remark}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        ))}
                    </div>
                </div>
            </div>
        </Spin>)
    }
}

Details.defaultProps = {

}

export default Details
